import { render } from "./ProductDetailMaximumOrderQuantity.vue?vue&type=template&id=2686d5ce&scoped=true&ts=true"
import script from "./ProductDetailMaximumOrderQuantity.vue?vue&type=script&lang=ts"
export * from "./ProductDetailMaximumOrderQuantity.vue?vue&type=script&lang=ts"

import "./ProductDetailMaximumOrderQuantity.vue?vue&type=style&index=0&id=2686d5ce&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2686d5ce"]])

export default __exports__